<script>
import Loading from "../../Loading.vue";
import {mapState} from "vuex";
import {getEffectiveContracts} from "../../utils/api/effectiveContract.api.service";

export default {
  name: "EffectiveContractAccessTable",
  components: {Loading},

  data() {
    return {
      loading: false,
      headers: [
        {
          text: "Тип",
          value: "kind",
          groupable: false,
          sortable: false,
          divider: true,
        },
        {
          text: "Название",
          value: "indicator_name",
          width: "40%",
          groupable: false,
          sortable: false,
        },
        {
          text: "Позиция",
          value: "position",
          width: "15%",
          groupable: false,
          sortable: false,
        },
        {
          text: "Должность",
          value: "degree",
          width: "20%",
          groupable: false,
          sortable: false,
          divider: true,
        },
        {
          text: "План",
          value: "plan",
          width: "20%",
          groupable: false,
          sortable: false,
        },
        {
          text: "Авторасчёт",
          value: "is_auto",
          width: "10%",
          groupable: false,
          sortable: false,
        },
      ],
      data: [],
      itemsPerPage: 999,
      page: 1,
    }
  },

  async mounted() {
    const [data, error] = await getEffectiveContracts();
    if (!_.isNull(error)) {
      return console.error(error);
    }
    this.data = data;
  },

  computed: {

    ...mapState({
      academicTitle: state => state.effective_contract.payloadOrder.academic_title,
      bid: state => state.effective_contract.payloadOrder.bid,
      dean: state => state.effective_contract.payloadOrder.dean,
      headDepartment: state => state.effective_contract.payloadOrder.head_department,
    }),

    numberOfPages () {
      return Math.ceil(this.items.length / this.itemsPerPage)
    },

    sortItemsByIndicatorName() {
      return _.sortBy(this.data, ['indicator_name'])
    },

    filteredItemsByOrderParams() {
      if (_.isEmpty(this.academicTitle) || _.isEmpty(this.bid)) return [];
      return this.filteredItems();
    },

    items() {
      if (_.isEmpty(this.filteredItemsByOrderParams)) return [];
      return _.sortBy(this.refactorPlanByBid(), [(item) => item.position === 'Оклад' ? 0 : 1, 'position']);
    }
  },

  methods: {

    filteredItems() {
      let filteredItems = []

      filteredItems = _.filter(this.sortItemsByIndicatorName, (it) => {
        const position = it?.position;
        const isSalary = this.filteredEffectiveContractsBySalaryPosition(position)
        const isHeadDepartment = this.headDepartment ? this.filteredEffectiveContractsByHeadDepartment(position) : false
        const isDean = this.dean ? this.filteredEffectiveContractsByDean(position) : false

        return isSalary || isHeadDepartment || isDean;
      });

      filteredItems = _.filter(filteredItems, (it) => {
        const degree = it?.degree
        return this.filteredEffectiveContractsByIndicatorName(degree)
      })

      return filteredItems;
    },

    refactorPlanByBid() {
      return _.map(this.filteredItemsByOrderParams, (it) => {

        const cloneIt = _.cloneDeep(it);
        const oldPlan = cloneIt?.plan;
        if (
          it.is_publication &&
          it.position === "Оклад" ||
          it.position === "Оклад" &&
          it.indicator_name === "Доход АмГУ от НИР, НИОКР, привлеченный работником"
        ) {
          cloneIt.plan = (oldPlan * Number(this.bid)).toFixed(2).toString();
        }
        return cloneIt
      })
    },

    filteredEffectiveContractsByIndicatorName(degree) {
      if (_.isEmpty(this.academicTitle)) return false

      if (_.isNull(degree)) return true

      return this.academicTitle.toLowerCase() === degree;
    },

    filteredEffectiveContractsByHeadDepartment(position) {
      return position === "Заведующий кафедрой"
    },

    filteredEffectiveContractsByDean(position) {
      return position === "Декан"
    },

    filteredEffectiveContractsBySalaryPosition(position) {
      if(_.isNull(position)) return false
      return position === "Оклад"
    },

  },
}

</script>

<template>
  <loading :loading="loading" :height-card="15">
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-0"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      hide-default-footer
      height="60vh"
      fixed-header
      group-by="kind"
    >
      <template #group.header="{items, isOpen, toggle}">
        <th
          :colspan="headers.length"
          class="header--group-by"
        >
          <div class="text-body-1 d-flex align-center">
            <v-icon small @click="toggle" class="mr-1">{{ isOpen ? 'fa-chevron-up' : 'fa-chevron-down' }}</v-icon>
            {{ items[0].kind === 'basic' ? 'Базовая' : 'Стимулирующая'}}
          </div>
        </th>
      </template>
      <template #item.number="{item}">
        {{items.indexOf(item) + 1}}
      </template>
      <template #item.plan="{item}">
        {{item.plan}} ({{item.units_measurement}})
      </template>
      <template #item.degree="{item}">
        {{item.degree || "Без разделения на должности"}}
      </template>
      <template #item.is_auto="{item}">
        <span v-if="item.is_auto" class="font-weight-bold ">Да</span>
        <span v-else>Нет</span>
      </template>
      <template #no-data>
        Список показателей ЭК пуст
      </template>
    </v-data-table>
  </loading>
</template>

<style scoped>

</style>